

const ToolbarPageTitle = () => {
  return (
    <></>
  )
}

export { ToolbarPageTitle }
